import { cva } from 'class-variance-authority';

const chipBaseStyles = [
  'rounded-full',
  'cursor-pointer',
  'select-none',
  'font-semibold',
  'py-2',
  'px-4',
  'inline-flex',
  'items-center',
  'gap-2',
  'text-sm',
  'leading-none',
];

const chipStylesSAG = cva([
  ...chipBaseStyles,
  'border',
  'border-[#007993]',
  'text-[#007993]',
  'bg-transparent',

  'hover:border-[#005159]',
  'hover:text-[#005159]',
  'hover:bg-[#D1FFF2]',

  'active:bg-transparent',

  'dark:border-[#00CCCC]',
  'dark:text-[#00CCCC]',

  'dark:hover:border-[#00FFB9]',
  'dark:hover:text-[#00FFB9]',
  'dark:hover:bg-[#001F39]',

  'dark:active:bg-transparent',
]);

const chipStylesSelectedSAG = cva([
  ...chipBaseStyles,
  'border',
  'border-[#007993]',
  'text-white',
  'bg-[#007993]',

  'hover:border-[#005159]',
  'hover:text-[#005159]',
  'hover:bg-[#D1FFF2]',

  'active:bg-white',

  'dark:border-[#00FFB9]',
  'dark:text-[#000028]',
  'dark:bg-[#00FFB9]',

  'dark:hover:border-[#00E5AA]',
  'dark:hover:text-[#00E5AA]',
  'dark:hover:bg-[#001F39]',

  'dark:active:bg-transparent',
]);

const chipStylesSHS = cva([
  ...chipBaseStyles,
  'border',
  'border-[#b3b3b3]',
  'text-[#1a1a1a]',
  'bg-white',

  'hover:bg-[#f2f2f2]',

  'dark:border-[#4d4d4d]',
  'dark:text-[#e6e6e6]',
  'dark:bg-[#1a1a1a]',

  'dark:hover:bg-[#313131]',
]);

const chipStylesSelectedSHS = cva([
  ...chipBaseStyles,
  'border',
  'border-[#cf4c00]',
  'text-[#e6e6e6]',
  'bg-[#cf4c00]',

  'hover:bg-[#ba4400]',
  'hover:border-[#ba4400]',
]);

export {
  chipStylesSelectedSAG,
  chipStylesSAG,
  chipStylesSHS,
  chipStylesSelectedSHS,
};
